import React, { Component } from 'react';

class GigsFilter extends Component {
  handleChange = (e) => {
    var val = e.currentTarget.value;
    if(val === 'select'){
      val = this.props.currMonth + ' ' + this.props.currYear;
    }
    var month = val.substr(0, val.indexOf(' ')); 
    var year = val.substr(val.length - 4);
    this.props.getCurrentEvents(this.props.events, month, year);
  }
  render(){

    return(
      <select className="gig-month-select" onChange={this.handleChange}>
        <option defaultValue value='select' readOnly>Choose another month</option>
        {this.props.choices.map((val,idx) => (
          <option key={idx} value={`${val.Month} ${val.Year}`}>{val.Month} {val.Year}</option>
        ))}
      </select>
    );
  }
}
export default GigsFilter;


// WEBPACK FOOTER //
// ./src/modules/pieces/GigsFilter.js